import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { useEntityScores } from "src/context/Scores/useEntityScores";
import { Score } from "src/types";
import { filterActionPlanEligibleScores } from "src/utils/actionPlanScoreFilters";
import { getActionPlanScoreIdsByType } from "src/utils/scores";

export const useActionPlanEligibleScores = (): Score[] => {
    const { entityScores } = useEntityScores();
    const { scoreTypes } = useFoodpilotContext();

    return filterActionPlanEligibleScores(entityScores, getActionPlanScoreIdsByType("company", scoreTypes));
};
